import { useEffect, useState } from "react";

export default function useSurveyForm({ defaultValues = {} }) {
  const [values, setValues] = useState(defaultValues || {});

  useEffect(() => {
    if(Object.keys(values).length === 0 && Object.keys(defaultValues).length > 0) {
      setValues(defaultValues);
    }
  }, [defaultValues]);

  const onChangeValue = (key, value) => {
    setValues(prev => ({ ...prev, [key]: value }));
  }

  return {
    values,
    onChangeValue
  }
}